import { render } from "./singleStory.vue?vue&type=template&id=55b73295&scoped=true"
import script from "./singleStory.vue?vue&type=script&lang=js"
export * from "./singleStory.vue?vue&type=script&lang=js"

import "./singleStory.vue?vue&type=style&index=0&id=55b73295&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ynyan\\Desktop\\官网\\YNOfficialwebsite\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55b73295"]])

export default __exports__